<template>
  <div class="modal to-top" :class="{ 'is-active': active }">
      <div class="modal-background"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $t("Cash") }}</p>
          </header>
          <section class="modal-card-body has-text-centered">
            <div class="card">
                <div class="card-content">
                    <template v-if="step == 1">
                        <p class="has-text-centered">
                            <img :src="imgData">
                        </p>
                        <p v-for="line in lines" :key="line.id" class="has-text-centered padding-bottom-1rem" v-html="line"></p>
                    </template>
                    <template v-if="step == 2">
                        <p class="has-text-centered">{{ $t("ThankYourForYourPurchase") }}</p>
                    </template>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot has-text-centered">
          <template v-if="step == 1">
            <a @click="cancel()" class="button is-info is-fullwidth">
                <span class="icon">
                    <i class="fa fa-times"></i>
                </span>
                <span>{{ $t("Cancel") }}</span>
            </a>
            <a @click="next()" class="button is-primary is-fullwidth">
                <span class="icon">
                    <i class="fa fa-arrow-right"></i>
                </span>
                <span>{{ $t("Next") }}</span>
            </a>
          </template>
          <template v-if="step == 2">
            <a @click="close()" class="button is-info is-fullwidth">
                <span class="icon">
                    <i class="fa fa-times"></i>
                </span>
                <span>{{ $t("Close") }}</span>
            </a>
          </template>
        </footer>
      </div>
  </div>
</template>

<script>
export default {
  name: "CashModal",
  props: {
    active: Boolean
  },
  mounted: async function()
  {
    const text = `${this.user.callingCode}.${this.user.mobile}`;
    const response = await this.$http.get(`/Utilities/QrCode?text=${text}`);
    this.imgData = `data:${response.data.contentType};base64,${response.data.imageData}`;
    this.lines = this.$t("CashBody", {qrIcon: `<i class="fa fa-qrcode"></i>`, mobile: `+${this.user.callingCode}${this.user.mobile}`}).split("\\n");
  },
  data()
  {
      return {
          step: 1,
          imgData: null,
          lines: []
      }
  },
  methods:
  {
      cancel: function()
      {
          this.$parent.paymentMethod = "disabled";
      },
      next: function()
      {
          this.step = 2;
      },
      close: async function()
      {
          await this.updateUser();
          this.$router.push("/");
      }
  }
};
</script>